// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Turnover_select__qsBIK {
  margin-top: 20px;
}

.Turnover_checkbox__vQi5k {
  border: 1px solid #d8d8ff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}
.Turnover_checkbox__vQi5k label {
  font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Turnover/Turnover.module.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;AAKJ;;AAFA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAKJ;AAHI;EAAO,gBAAA;AAMX","sourcesContent":["@use 'styles/colors.scss';\n\n.select{\n    margin-top: 20px;\n}\n\n.checkbox{\n    border: 1px solid colors.$primary2;\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 12px;\n\n    label{ font-weight: 300; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"select": `Turnover_select__qsBIK`,
	"checkbox": `Turnover_checkbox__vQi5k`
};
export default ___CSS_LOADER_EXPORT___;
